import React, {useEffect, useState} from 'react';
import {Button, Container, Grid, TextField, Typography} from '@mui/material';
import {makeStyles} from 'tss-react/mui';
import {useContabilidadPropietario} from '../hooks/useContabilidadPropietario';
import {
   ContabilidadPropietario,
   DatosPropietarioContabilidad
} from '../../bussines/entities/contabilidadesPropietario.entity';
import {SelectPlus, toast} from 'lib.front';
import SearchIcon from '@mui/icons-material/Search';
import {DatePicker} from '@mui/x-date-pickers';

const useStyles = makeStyles()(theme => ({
   container: {
      marginTop: theme.spacing(2)
   },
   input: {
      maxWidth: '500px',
   },
   datePicker: {
      width: '-webkit-fill-available'
   }
}));

const BuscadorGuid: React.FC = () => {
   const {classes, cx} = useStyles();
   const [contabilidadList, setContabilidadList] = useState<ContabilidadPropietario[]>([]);
   const [contabilidadSelect, setContabilidadSelect] = useState<any>(null);
   const [dataPropietario, setDataPropietario] = useState<DatosPropietarioContabilidad | null>(
      null
   );
   const {
      getContabilidadPropietarioList,
      getDatosContabilidadPropietario
   } = useContabilidadPropietario();
   const fetchContabilidadPropList = async () => {
      const result = await getContabilidadPropietarioList();
      if (result) setContabilidadList(result);
   };
   const fetchPropietarioData = async () => {
      if (contabilidadSelect) {
         const result = await getDatosContabilidadPropietario({
            idCuenta: contabilidadSelect.dataItem?.idPropietarioContabilidad
         });
         if (result) setDataPropietario(result);
      } else toast.showError('Seleccione una contabilidad.');
   };

   const parseDate = (date: string | undefined) => {
      if (!date) {
         return null;
      }
      const parsedDate = new Date(date);
      const maxDate = new Date('2099-12-31T23:59:59.999Z');
      if (parsedDate > maxDate) {
         return maxDate; // Ajustamos a la fecha máxima
      }
      return parsedDate;
   };

   const clear = () => {
      setDataPropietario(null);
      setContabilidadSelect(null);
   };

   useEffect(() => {
      fetchContabilidadPropList();
   }, []);

   return (
      <Container className={cx('containerbox', classes.container)} maxWidth="lg">
         <Grid container spacing={1}>
            <Grid item xs={12}>
               <Typography variant="h4" gutterBottom align="center">
                  Buscador de GUIDs
               </Typography>
            </Grid>
            <Grid container item xs={12} spacing={1} paddingBottom={2}>
               <Grid item lg={6} md={7} sm={9} xs={10}>
                  <SelectPlus
                     //@ts-ignore
                     name="guid"
                     label="GUID"
                     variant="outlined"
                     value={contabilidadSelect}
                     onChange={(e: any) => setContabilidadSelect(e)}
                     margin="dense"
                     data={contabilidadList}
                     genLabel={(item: ContabilidadPropietario) => item.idContabilidad}
                     className={classes.input}
                     fullWidth
                     isClearable
                     placeholder="Seleccione un codigo"
                  />
               </Grid>
               <Grid item lg={6} md={5} sm={3} xs={2} alignContent="center">
                  <Button
                     onClick={() => fetchPropietarioData()}
                     startIcon={<SearchIcon />}
                     variant="contained"
                  ></Button>
               </Grid>
            </Grid>
            <Grid container item spacing={2}>
               <Grid item xs={12} sm={4}>
                  <TextField
                     id="codCliente"
                     variant="outlined"
                     label="Cod. Cliente/RUC/DNI"
                     value={dataPropietario?.codigoCliente || ''}
                     disabled
                     inputProps={{
                        readOnly: true
                     }}
                     size="small"
                     className={classes.input}
                     fullWidth
                  />
               </Grid>
               <Grid item xs={12} sm={5}>
                  <TextField
                     id="denominacionCliente"
                     variant="outlined"
                     label="Razón Social/ Nombre"
                     value={dataPropietario?.denominacionCliente || ''}
                     disabled
                     inputProps={{
                        readOnly: true
                     }}
                     size="small"
                     className={classes.input}
                     fullWidth
                  />
               </Grid>
               <Grid item xs={12} sm={3}>
                  <TextField
                     id="email"
                     variant="outlined"
                     label="Correo"
                     value={dataPropietario?.email || ''}
                     disabled
                     inputProps={{
                        readOnly: true
                     }}
                     size="small"
                     className={classes.input}
                     fullWidth
                  />
               </Grid>
               <Grid item lg={3} md={4} sm={6}>
                  <TextField
                     id="plan"
                     variant="outlined"
                     label="Plan"
                     value={dataPropietario?.denominacionPlan || ''}
                     disabled
                     inputProps={{
                        readOnly: true
                     }}
                     size="small"
                     className={classes.input}
                     fullWidth
                  />
               </Grid>
               <Grid item lg={3} md={4} sm={6}>
                  <TextField
                     id="recurrencia"
                     variant="outlined"
                     label="Suscripción"
                     value={dataPropietario?.recurrencia || ''}
                     disabled
                     inputProps={{
                        readOnly: true
                     }}
                     size="small"
                     className={classes.input}
                     fullWidth
                  />
               </Grid>
               <Grid item lg={3} md={4} sm={6}>
                  <DatePicker
                     label="Fecha de Expiración"
                     onChange={() => {}}
                     value={parseDate(dataPropietario?.fechaExpiracion)}
                     format="dd/MM/yyyy"
                     readOnly
                     className={cx(classes.input, classes.datePicker)}
                     disabled
                  />
               </Grid>
               <Grid item lg={3} md={4} sm={6}>
                  <TextField
                     id="almacenamiento"
                     variant="outlined"
                     type="number"
                     label="Almacenamiento"
                     value={dataPropietario?.almacenamiento || ''}
                     disabled
                     inputProps={{
                        readOnly: true
                     }}
                     size="small"
                     className={classes.input}
                     fullWidth
                  />
               </Grid>
            </Grid>
            <Grid item xs={12} container justifyContent="flex-end" marginTop={2}>
               <Button variant="contained" onClick={clear}>
                  Cancelar
               </Button>
            </Grid>
         </Grid>
      </Container>
   );
};

export default BuscadorGuid;
